import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { StatusProps } from '@/models/Status';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function useStatus() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const getAllStatuses = useCallback(async (): Promise<StatusProps[]> => {
    const url = `${baseUrl}status`;
    const data = await customFetch<StatusProps[]>(url, {
      method: 'GET',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
        Authorization: `Bearer ${authResult.accessToken}`,
      },
    });

    if (!Array.isArray(data)) {
      throw new Error('Expected array response');
    }

    return data;
  }, [customFetch, authResult]);

  return {
    getAllStatuses,
  };
}
